/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrdersResponseGetRecordsList } from '../../models/orders-response-get-records-list';

export interface OrdersControllerGetOrders$Params {

/**
 * A required project id for which the orders were created.
 */
  projectId: string;
}

export function ordersControllerGetOrders(http: HttpClient, rootUrl: string, params: OrdersControllerGetOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<OrdersResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, ordersControllerGetOrders.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrdersResponseGetRecordsList>;
    })
  );
}

ordersControllerGetOrders.PATH = '/planning-projects/v1/orders';
